import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import {
  //ButtonBase,
  //Button,
  Box,  
} from '@mui/material';

import dadosSessoes from './DadosSessoes';


const ITEM_HEIGHT = 50;
const ITEM_PADDING_TOP = 5;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const categorias = [
  'Reforço Muscular',
  'Ganho de Amplitude Articular',
  'Alongamento',
  'Exercicio Aeróbio',
  'Reeducação Postural'
];


export default function FilterSessao() {
  
    const [categoria, setCategoria] = React.useState([]);

    const handleChangeCategoria = (event) => {
        const {
        target: { value },
        } = event;
        setCategoria(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value.split(',') : value,
        );
    };


  return (
    <Box paddingTop={1}>
      <FormControl sx={{ m: 0, width: 300 }}>
        <InputLabel id="demo-multiple-checkbox-label">Selecionar sessão...</InputLabel>
        <Select
          multiple
          value={categoria}
          onChange={handleChangeCategoria}
          input={<OutlinedInput label="Categoria" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {dadosSessoes.map((name,index) => (
            <MenuItem key={index} value={name.title}>
              <Checkbox checked={categoria.indexOf(name.title) > -1} />
              <ListItemText primary={name.title} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>    
  );
}